import { useTranslation } from 'react-i18next'
import { Text } from '~/components/typography'
import { useAppStore } from '~/hooks'
import Chevron from '~/assets/icons/chevron.svg?react'

import { Disclosure, DisclosureButton, DisclosurePanel, Transition } from '@headlessui/react'
import { cn } from '~/util'

import { Cosmos } from '../LegendContent/Cosmos'
import { CalWaves } from '../LegendContent/CalWaves'
import { Erosion } from '../LegendContent/Erosion'

function Legend() {
  const { t } = useTranslation()
  const { basemapType, dataset } = useAppStore()

  return (
    <div
      className={cn(
        'flex max-h-[400px] w-[284px] flex-col overflow-hidden rounded-xl bg-neutral-off-white text-start sm:max-h-[calc(100vh_-_7rem)]',
        basemapType === 'FLAT' ? 'shadow-xl' : ''
      )}
    >
      <Disclosure defaultOpen={window.innerWidth > 639}>
        {({ open }) => (
          <>
            <DisclosureButton className="group">
              <div className="flex items-center justify-between px-4 pb-1 pt-1 group-data-[open]:border-b group-data-[open]:pt-2">
                <Text level={1} className="text-neutral-midfi-grey">
                  {t('legend.layers')}
                </Text>

                <Chevron className="group-data-[open]:rotate-180" />
              </div>
            </DisclosureButton>

            <Transition
              show={open}
              enter="transition transition-[max-height] duration-200 ease-in"
              enterFrom="transform max-h-0"
              enterTo="transform max-h-screen"
              leave="transition transition-[max-height] duration-400 ease-out"
              leaveFrom="transform max-h-screen"
              leaveTo="transform max-h-0"
            >
              <DisclosurePanel className="flex max-h-[calc(100vh_-_8rem)] flex-col gap-2 space-y-2 overflow-y-auto p-4">
                <div className="space-y-4">
                  {dataset === 'waves' && <CalWaves />}
                  {dataset === 'cosmos' && <Cosmos />}
                  {dataset === 'erosion' && <Erosion />}
                </div>
              </DisclosurePanel>
            </Transition>
          </>
        )}
      </Disclosure>
    </div>
  )
}

export default Legend
